export class SidebarItem {
  constructor(
    public id: string,
    public srcIcon: string,
    public svgContent: string,
    public titleId: string,
    public title: string,
    public submenuLevel: number,
    public position: number,
  ) {}
}
